export enum ActionBarAction {
  DISABLE = 'disabled_action',
  ENABLE = 'enabled_action',
  SAVE_DONE  = 'save_done',
  ON_SAVE = 'on_save',
  ON_SAVE_CLOSE = 'on_save_close',
  CLOSE = 'close',
  REFRESH = 'refresh',
  NORMAL_REFRESH = 'normal_refresh',
  DISABLE_NEW = 'disable_new',
  ENABLE_NEW = 'enable_new',
  CASCADE = 'cascade',
  DELETE = 'delete',
  CLOSE_FORM = 'C',
  NEW = 'new'
}
